export const OC_CONTRACT_ORDER = {
  desktop: `
  <div class="cui cui-grid cui-container">
    <div class="cui-row -spacing--top-80 -spacing--bottom-40">
      <div class="cui-col-xl-8 cui-col-md-8">
        <div class="cui-skeleton-heading -size--large -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-xl-8 cui-col-md-8">
        <div class="cui-skeleton-heading -size--large -spacing--bottom-120 -resolution--desktop">
          <div class="cui-skeleton-paragraph__content -spacing--bottom-40" style="width: 100%">
            <div class="cui-skeleton__item" style="height: 56px"></div>
          </div>
          <div class="cui-skeleton-paragraph__content -spacing--bottom-16" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40">
            <div class="cui-skeleton__item" style="width: 100%; height: 218px"></div>
          </div>
          <div class="cui-skeleton-button -size--medium">
            <div class="cui-skeleton-button__content" style="width: 160px;">
              <div class="cui-skeleton__item cui-skeleton-button__button"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-col-xl-3 cui-col-md-8 col-offset-xl-1">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-32">
          <div class="cui-skeleton__item" style="width: 100%; height: 88px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
          <div class="cui-skeleton__item" style="width: 100%; height: 88px"></div>
        </div>
      </div>
    </div>
  </div>
  `
};
